import { Screen40 } from "../../../../src/components/images/support/users/Screen40.generated";
import { Screen41 } from "../../../../src/components/images/support/users/Screen41.generated";
import { SupportFooter } from "../../../../src/components/SupportFooter";
import * as React from 'react';
export default {
  Screen40,
  Screen41,
  SupportFooter,
  React
};